/* __next_internal_client_entry_do_not_use__ default auto */ import useEnhancedEffect from '@mui/utils/useEnhancedEffect';
export default useEnhancedEffect;
